import { z } from 'zod';

export const boardSchema = z.object({
  name: z
    .string()
    .min(1, { error: 'boards.form.validation.nameRequired' })
    .max(100, { error: 'boards.form.validation.nameTooLong' }),
  description: z
    .string()
    .max(500, { error: 'boards.form.validation.descriptionTooLong' })
    .optional(),
});

export type BoardFormValues = z.infer<typeof boardSchema>;

export const boardStatusSchema = z.object({
  name: z
    .string()
    .min(1, { error: 'boards.statuses.form.validation.nameRequired' })
    .max(50, { error: 'boards.statuses.form.validation.nameTooLong' }),
  color: z.string().min(1, { error: 'boards.statuses.form.validation.colorRequired' }),
  type: z.enum(['Todo', 'InProgress', 'Done'], {
    error: 'boards.statuses.form.validation.typeRequired',
  }),
  wipLimit: z
    .number()
    .int()
    .min(1)
    .optional()
    .refine((v) => v === undefined || !Number.isNaN(v), {
      error: 'boards.statuses.form.validation.wipLimitInvalid',
    }),
});

export type BoardStatusFormValues = z.infer<typeof boardStatusSchema>;

export const boardGroupSchema = z.object({
  name: z
    .string()
    .min(1, { error: 'boards.groups.form.validation.nameRequired' })
    .max(100, { error: 'boards.groups.form.validation.nameTooLong' }),
});

export type BoardGroupFormValues = z.infer<typeof boardGroupSchema>;
